import React from "react";
import PostListGuest from "../components/PostlistGuest";
import NewsCarousel from "../components/whatisnew/NewsCarousel";
import Guestheader from "./headers/guestheader";
import Bannerdisplay from "./banners/BannerDisplay";
import MessagefromCOE from "./banners/MessageCEO";
import Aboutus from "./banners/Aboutus";
import Joinus from "./banners/JoinUsFrames";
import TestimonialCarousel from "./banners/Testimonial";
import Coolevents from "./addCoolactivities/Evenlistverticalview";
import GroupListPublic from "../components/groups/GroupListPublic"; // still used inside main content
import "./Userguest.css";

const UserGuest = ({ onLike, likes, userLiked }) => {
  return (
    <>
      {/* ✅ Sticky Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Guestheader />
      </div>

      <div className="guest-page" style={styles.container}>
        <main style={styles.posts}>
          <Bannerdisplay />

          <div style={styles.sectionWrapper}>
            <MessagefromCOE />
          </div>

          <div className="guest-page-events">
            <Coolevents />
          </div>

          <div style={{ margin: "20px" }}>
            <GroupListPublic />
          </div>

          <PostListGuest
            user={null}
            onReply={() => {}}
            onRefresh={() => {}}
            onLike={onLike}
            likes={likes}
            userLiked={userLiked}
          />
          <NewsCarousel />
          <Aboutus />
          <TestimonialCarousel />
          <Joinus />
        </main>
      </div>
    </>
  );
};

const styles = {
container: {
  display: "flex",
  flexDirection: "column",
  background: "#f3f5f8",
  minHeight: "100vh",
  overflowY: "hidden", // ✅ fixed typo
    overflowX: "hidden", // ✅ prevents horizontal scroll too
},
  posts: {
    flex: 1,
    padding: "1px",
    overflowX: "hidden",
    width: "100%",
    boxSizing: "border-box",
    overflowY: "hidden", // ✅ fixed typo
  },
  sectionWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "15px",
    marginBottom: "20px",
    width: "100%",
  },
};

export default UserGuest;
